"use strict";

var _ = require("lodash");
require("templates/rtInputDropdown.html");

/**
 * Analogous to a native <select> element, but with customizable behavior and styling.
 *
 * options are provided by the rtOptionsProvider controller, and must be:
 *                An array of option objects, analogous to DOM <option> elements
 *                Each option object has the following properties:
 *                 - value: (required) the value associated with the model
 *                 - text: (required) the text to display for the option
 */
module.exports = /*@ngInject*/ function($rootScope, $document, scrollParent) {
  return {
    restrict: "E",
    require: ["ngModel", "rtOptionsProvider"],
    scope: {
      id: "@",
      disabled: "@",
      required: "@",
      label: "@"
    },
    templateUrl: "templates/rtInputDropdown.html",
    link: function(scope, element, attrs, controllers) {
      var ngModelController = controllers[0],
        rtOptionsProviderController = controllers[1],
        scrollableParent = scrollParent(element);

      var disabledOptions = [];

      scope.isDropdownOpen = false;

      function getOptions() {
        return rtOptionsProviderController.getOptions();
      }

      function setOptionsOnScope(options) {
        if (!_.isArray(options)) {
          throw new Error("options: expected array, found " + options);
        }
        scope.options = _.difference(options, disabledOptions);
      }

      function updateDropdownDirection() {
        var parentTopOffset = scrollableParent.is($document)
          ? 0
          : scrollableParent.offset().top;

        var viewportBottom = parentTopOffset + scrollableParent.height(),
          elementBottom = element.offset().top + element.height(),
          dropdownHeight = element.find("ul.dropdown-menu").height(),
          dropdownOverflows =
            viewportBottom - elementBottom < dropdownHeight + 10;

        if (dropdownOverflows) {
          element.addClass("dropdown-top");
        } else {
          element.removeClass("dropdown-top");
        }
      }

      setOptionsOnScope(getOptions());

      scope.$watch(getOptions, setOptionsOnScope);

      scope.handleKeydown = function(event) {
        var handlers = {
          "38": handleUpArrow,
          "40": handleDownArrow,
          "13": handleEnter
        };
        var keyHandler = handlers[event.keyCode];
        if (keyHandler) {
          event.preventDefault();
          keyHandler();
        }
      };

      scope.setModel = function(value) {
        ngModelController.$setViewValue(value);
        ngModelController.$render();
      };

      scope.initHighlightedOption = function() {
        scope.highlightedOption = _.findIndex(scope.options, function(option) {
          return option.value === ngModelController.$viewValue;
        });
        scope.selectedOption = scope.options[scope.highlightedOption];
      };

      scope.$watchGroup(["isDropdownOpen", "options"], function() {
        scope.initHighlightedOption();

        if (scope.isDropdownOpen) {
          updateDropdownDirection();
        }
      });

      scope.$watch("isDropdownOpen", function(newValue, oldValue) {
        if (!newValue && oldValue) {
          element.find("button").focus();
        }
      });

      ngModelController.$render = scope.initHighlightedOption;

      function handleUpArrow() {
        if (scope.isDropdownOpen) {
          if (scope.highlightedOption === -1) {
            scope.highlightedOption = 0;
          } else if (scope.highlightedOption > 0) {
            scope.highlightedOption--;
          }
        }
        scope.isDropdownOpen = true;
      }

      function handleDownArrow() {
        var highlightedOptionIsNotLastOption =
          scope.highlightedOption < scope.options.length - 1;
        if (highlightedOptionIsNotLastOption && scope.isDropdownOpen) {
          scope.highlightedOption++;
        }
        scope.isDropdownOpen = true;
      }

      function handleEnter() {
        if (
          scope.highlightedOption >= 0 &&
          scope.highlightedOption < scope.options.length
        ) {
          scope.setModel(scope.options[scope.highlightedOption].value);
        }
        scope.isDropdownOpen = !scope.isDropdownOpen;
      }
    }
  };
};



// WEBPACK FOOTER //
// ./app/ui/directives/rtInputDropdown.js